import { render, staticRenderFns } from "./RegistrosCideCombustivel.vue?vue&type=template&id=979f6416&scoped=true&"
import script from "./RegistrosCideCombustivel.vue?vue&type=script&lang=js&"
export * from "./RegistrosCideCombustivel.vue?vue&type=script&lang=js&"
import style0 from "./RegistrosCideCombustivel.vue?vue&type=style&index=0&id=979f6416&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "979f6416",
  null
  
)

export default component.exports